// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Courses_wrapper__3bapG","card-wrapper":"Courses_card-wrapper__38-rW","spinner":"Courses_spinner__1v_Ii"};